export type { ModalContentRequestSuccessProps } from './ModalContentRequestSuccess'
export { default } from './ModalContentRequestSuccess'
